import { render, staticRenderFns } from "./ajpc.vue?vue&type=template&id=27de8504&scoped=true&"
import script from "./ajpc.vue?vue&type=script&lang=js&"
export * from "./ajpc.vue?vue&type=script&lang=js&"
import style0 from "./ajpc.vue?vue&type=style&index=0&id=27de8504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27de8504",
  null
  
)

export default component.exports